// Minimal process polyfill for browser environments
// Some Node.js modules expect process to exist

if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = {
    env: {},
    cwd: () => '/',
    argv: [],
    exit: () => {},
    nextTick: (fn) => setTimeout(fn, 0),
  };
}
